import Vue from "vue";

Vue.prototype.$hasPermission = function (
  user,
  roleNameToCheck,
  strictCheck = false
) {
  if (!user || !user.roles || !Array.isArray(user.roles)) {
    return false;
  }

  // Admin and Geschäftsführung have all permissions (unless strict check is requested)
  if (
    !strictCheck &&
    (user.roles.includes("Admin") || user.roles.includes("Geschäftsführung"))
  ) {
    return true;
  }

  // Check if user has any of the required roles
  if (Array.isArray(roleNameToCheck)) {
    return user.roles.some((role) => roleNameToCheck.includes(role));
  }

  return user.roles.includes(roleNameToCheck);
};
